/* eslint-disable react/forbid-prop-types */
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { TextareaInput } from 'components/FormControl';
import React from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { adjustmentReasonSchema } from 'features/Project/validation';

function AdjustmentReasonDialog({ visible, onClose, data }) {
  const { t } = useTranslation();
  const {
    control,
    formState: { errors },
    watch,
    reset,
  } = useForm({
    mode: 'onChange',
    resolver: yupResolver(adjustmentReasonSchema),
  });

  const formatHeader = () => <p>{t('projectAdjustment.reasonModal.title')}</p>;

  const { item, index, update } = data;

  const onSubmit = () => {
    const reason = watch('reason');
    update(index, {
      email: item?.email,
      contact: item?.contact,
      fullname: item?.fullname,
      gender: item?.gender,
      academicRank: item?.academicRank,
      academicDegree: item?.academicDegree,
      researchLines: item?.researchLines,
      assignedTask: item?.assignedTask,
      isAuthorized: item?.isAuthorized,
      projectRoleId: item?.projectRoleId,
      organizationId: item?.organizationId,
      specificOrganizationName: item?.specificOrganizationName,
      isDelete: true,
      reason,
    });
    reset();
    onClose();
  };

  return (
    <Dialog
      header={formatHeader}
      visible={visible}
      position="center"
      style={{ width: '600px' }}
      onHide={onClose}
      draggable={false}
    >
      <div className="p-fluid">
        <TextareaInput
          name="reason"
          label={t('projectAdjustment.reasonModal.reason')}
          control={control}
          errors={errors}
          row={6}
          isRequired
          defaultValue={item?.reason || ''}
        />
        <div className="flex justify-content-end gap-2 mt-4">
          <Button
            type="button"
            label={t('employee.cancel')}
            className="w-7rem"
            severity="danger"
            onClick={onClose}
            autoFocus
          />
          <Button
            label={t('formLayout.action.update')}
            className="w-7rem"
            severity="info"
            type="button"
            onClick={onSubmit}
          />
        </div>
      </div>
    </Dialog>
  );
}

AdjustmentReasonDialog.propTypes = {
  visible: PropTypes.bool,
  onClose: PropTypes.func,
  data: PropTypes.object,
};

AdjustmentReasonDialog.defaultProps = {
  visible: false,
  onClose: () => {},
  data: {},
};

export default React.memo(AdjustmentReasonDialog);
